import React from 'react';
import { HelpCenterSettingsRedirect } from '@atlassian/jira-servicedesk-customer-service-common/src/ui/help-center-settings-redirect/HelpCenterSettingsRedirectOld.tsx';
import type ProjectSettingsServiceDeskEmailType from '@atlassian/jira-spa-apps-project-settings-service-desk-email/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskEmail = lazyForPaint<
	typeof ProjectSettingsServiceDeskEmailType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-email", jiraSpaEntry: "async-project-settings-service-desk-email" */ '@atlassian/jira-spa-apps-project-settings-service-desk-email'
		),
);

const AsyncProjectSettingsServiceDeskEmail = (): React.JSX.Element => (
	<HelpCenterSettingsRedirect page="email">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskEmail}
			pageId="project-settings-email"
			shouldShowSpinner
		/>
	</HelpCenterSettingsRedirect>
);

export default AsyncProjectSettingsServiceDeskEmail;
